import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-141">
      <div className="absolute inset-0 bg-emerald-900/5 pointer-events-none" data-id="element-142" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-144">
          <Quote className="absolute -top-6 -left-6 w-16 h-16 text-emerald-500/20 rotate-180" data-id="element-145" />

          <blockquote className="text-2xl md:text-3xl text-center text-white font-medium leading-relaxed px-8" data-id="element-146">
            En los primeros 7 días, notarás que la "neblina" de media tarde
            desaparece. Tu capacidad para enfocarte en tareas complejas
            regresará y, por primera vez en años, te despertarás antes de que
            suene la alarma, sintiendo que tu cuerpo está listo para actuar, no
            para sobrevivir.
          </blockquote>

          <Quote className="absolute -bottom-6 -right-6 w-16 h-16 text-emerald-500/20" data-id="element-147" />
        </motion.div>
      </div>
    </section>;
}